module.exports = __webpack_public_path__ + "static/media/tpay.f389746a.svg";